import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

const TextFieldInput = styled(TextField)({
    '& .MuiInputLabel-root': {
        fontSize: '16px',
        top: '-5px',
        color: '#6B6B6B',
        background:'#fff'
    },
    '& .MuiInputBase-root': {
        fontSize: '15px',
        borderRadius: "8px",
    },
    '& .MuiInputBase-input': {
        padding: "12px 14px",
    },
    "& fieldset": {
      border:'1px solid #0D0D0D',
    },
})

export default TextFieldInput;